// REACT
import React, { Component } from "react";
import "./RemoteSensing.scss";
import NDMInterpretation from "./NDMInterpretation";

const borderValues = [
  -1.1, -0.8, -0.5, -0.37, -0.24, -0.18, -0.13, -0.08, -0.032, -0.024, -0.016,
  -0.008, 0, 0.008, 0.016, 0.024, 0.03, 0.07, 0.13, 0.18, 0.24, 1,
];

class NDMIpanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      legendArrowMargin: 5,
      indexValue: this.props.indexValue,
    };
  }

  componentDidMount() {
    this.setState({
      legendArrowMargin: 5,
      indexValue: "",
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.indexValue !== this.props.indexValue) {
      this.setState({
        indexValue: this.props.indexValue,
      });

      const ndmi = parseFloat(this.props.indexValue);
      let newMargin = "";

      if (ndmi <= borderValues[0]) {
        newMargin = -29;
      } else if ((ndmi > borderValues[0]) & (ndmi <= borderValues[1])) {
        newMargin = -22;
      } else if ((ndmi > borderValues[1]) & (ndmi <= borderValues[2])) {
        newMargin = -10;
      } else if ((ndmi > borderValues[2]) & (ndmi <= borderValues[3])) {
        newMargin = 4;
      } else if ((ndmi > borderValues[3]) & (ndmi <= borderValues[4])) {
        newMargin = 20;
      } else if ((ndmi > borderValues[4]) & (ndmi <= borderValues[5])) {
        newMargin = 33;
      } else if ((ndmi > borderValues[5]) & (ndmi <= borderValues[6])) {
        newMargin = 47;
      } else if ((ndmi > borderValues[6]) & (ndmi <= borderValues[7])) {
        newMargin = 61;
      } else if ((ndmi > borderValues[7]) & (ndmi <= borderValues[8])) {
        newMargin = 75;
      } else if ((ndmi > borderValues[8]) & (ndmi <= borderValues[9])) {
        newMargin = 89;
      } else if ((ndmi > borderValues[9]) & (ndmi <= borderValues[10])) {
        newMargin = 102;
      } else if ((ndmi > borderValues[10]) & (ndmi <= borderValues[11])) {
        newMargin = 115;
      } else if ((ndmi > borderValues[11]) & (ndmi < borderValues[12])) {
        newMargin = 130;
      } else if (ndmi === borderValues[12]) {
        newMargin = 134;
      } else if ((ndmi > borderValues[12]) & (ndmi <= borderValues[13])) {
        newMargin = 148;
      } else if ((ndmi > borderValues[13]) & (ndmi <= borderValues[14])) {
        newMargin = 162;
      } else if ((ndmi > borderValues[14]) & (ndmi <= borderValues[15])) {
        newMargin = 176;
      } else if ((ndmi > borderValues[15]) & (ndmi <= borderValues[16])) {
        newMargin = 188;
      } else if ((ndmi > borderValues[16]) & (ndmi <= borderValues[17])) {
        newMargin = 202;
      } else if ((ndmi > borderValues[17]) & (ndmi <= borderValues[18])) {
        newMargin = 216;
      } else if ((ndmi > borderValues[18]) & (ndmi <= borderValues[19])) {
        newMargin = 230;
      } else if ((ndmi > borderValues[19]) & (ndmi <= borderValues[20])) {
        newMargin = 244;
      } else if ((ndmi > borderValues[20]) & (ndmi <= borderValues[21])) {
        newMargin = 256;
      } else {
        newMargin = 3;
        this.setState({ indexValue: "" });
      }
      this.setState({ legendArrowMargin: newMargin });
    }
  }

  onToggleFilter = () => {
    const newIndex = this.state.toggleActiveIndex === 1 ? 0 : 1;
    this.setState({ toggleActiveIndex: newIndex });
  };

  render() {
    return (
      <div id="indexLegend">
        <div className="indexLegendTitle">Hodnota indexu:</div>
        <span
          id="outputIndex"
          style={{
            position: "relative",
            width: "294px",
            top: "-10px",
            left: this.state.legendArrowMargin + 22,
            fontWeight: "600",
          }}
        >
          {this.state.indexValue}
        </span>
        <img
          src={images["legend_arrow.png"]}
          alt="loading"
          style={{
            position: "relative",
            top: "8px",
            marginLeft: this.state.legendArrowMargin,
            height: "14px",
          }}
        />
        <img
          src={images["legend_ndmi.png"]}
          alt="loading"
          style={{
            position: "relative",
            top: "3px",
            height: "25px",
            padding: "0 12px",
          }}
        />
        <NDMInterpretation ndmi={this.state.indexValue} />
      </div>
    );
  }
}

export default NDMIpanel;

// IMPORT ALL IMAGES
const images = importAllImages(
  require.context("../../../sidebar/images", false, /\.(png|jpe?g|svg|gif)$/)
);
function importAllImages(r) {
  let images = {};
  r.keys().map((item, index) => (images[item.replace("./", "")] = r(item)));
  return images;
}